import React from 'react'
import { useIntl } from 'react-intl'

type Props = {
  from: number
  to: number
  total: number
}

export const PaginationRangeLabel: React.FC<Props> = ({ from, to, total }) => {
  const { locale, formatMessage } = useIntl()

  const format = (value: number) =>
    Number.isFinite(value)
      ? new Intl.NumberFormat(locale).format(value)
      : ''

  if (!Number.isFinite(total) || total <= 0) return null

  const safeFrom = Math.max(1, from)
  const safeTo = Math.max(safeFrom, to)

  return (
    <span>
      {formatMessage(
        {
          id: 'admin/common.pagination.range',
          defaultMessage: '{from} — {to} of {total}',
        },
        {
          from: format(safeFrom),
          to: format(safeTo),
          total: format(total),
        }
      )}
    </span>
  )
}

